// @flow

import { observer } from "mobx-react";
import * as React from "react";

import "./Modal.scss";

type Props = {
    children: React.Node,
    header?: any,
    footer?: any,
    onCancel?: Function
};

@observer
export default class Modal extends React.Component<Props> {
    render() {
        return (
            <div className="modal Modal">
                <div className="modal-dialog">
                    <div className="modal-content">
                        {this.renderHeader()}
                        <div className="modal-body">{this.props.children}</div>
                        {this.renderFooter()}
                    </div>
                </div>
            </div>
        );
    }

    renderHeader() {
        if (!this.props.header) return null;

        let cancelBtn = null;
        if (this.props.onCancel) {
            cancelBtn = (
                <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={this.props.onCancel.bind(this)}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            );
        }

        return (
            <div className="modal-header">
                {cancelBtn}
                <h4 className="modal-title">{this.props.header}</h4>
            </div>
        );
    }

    renderFooter() {
        if (!this.props.footer) return null;

        return <div className="modal-footer">{this.props.footer}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Modal/Modal.js